import { Modal, Table, Text, TextInput, TableProps } from '@mantine/core';
import { memo, useState } from 'react';
import styled from 'styled-components';
import { DataSimpleInvestorTct } from '@dealstack/shared/lib/generated/models/DataSimpleInvestorTct';

interface Props {
	isOpen: boolean;
	onClose: () => void;
	investors: DataSimpleInvestorTct[];
	onSelectInvestor: (investor: DataSimpleInvestorTct) => void;
}

const InvestorSelectModalBase = ({ isOpen, onClose, investors, onSelectInvestor }: Props) => {
	const [searchQuery, setSearchQuery] = useState('');

	const filteredInvestors = investors.filter((investor) => {
		const searchLower = searchQuery.toLowerCase();
		return (
			investor.user.firstName.toLowerCase().includes(searchLower) ||
			investor.user.lastName.toLowerCase().includes(searchLower)
		);
	});

	return (
		<Modal opened={isOpen} onClose={onClose} title="Select Investor" size="lg">
			<TextInput
				placeholder="Search by name..."
				value={searchQuery}
				onChange={(event) => setSearchQuery(event.currentTarget.value)}
				mb="md"
			/>
			<StyledTable>
				<thead>
					<tr>
						<th>First Name</th>
						<th>Last Name</th>
					</tr>
				</thead>
				<tbody>
					{filteredInvestors.map((investor) => (
						<StyledRow
							key={investor.id}
							onClick={() => {
								onSelectInvestor(investor);
								onClose();
							}}
						>
							<td>
								<Text>{investor.user.firstName}</Text>
							</td>
							<td>
								<Text>{investor.user.lastName}</Text>
							</td>
						</StyledRow>
					))}
				</tbody>
			</StyledTable>
		</Modal>
	);
};

const StyledTable = styled(Table)<TableProps>`
	width: 100%;
`;

const StyledRow = styled.tr`
	cursor: pointer;
	&:hover {
		background-color: #f5f5f5;
	}
`;

export const InvestorSelectModal = memo(InvestorSelectModalBase);
